$(function() {
	$('[data-toggle="favorites"]').on('click', function (e) {

		e.preventDefault();

		var $this = $(this);

		if ($this.data('locked')) return;

		$this.data('locked', true);

		axios.post($this.attr('href')).then(function (response) {

			var $item = $('[data-content="' + response.data.id + '"]');

			if(response.data.saved) {
				$item.addClass('bookmarked');
			} else {
				$item.removeClass('bookmarked');
			}

			$this.data('locked', false);
		}).catch(function(error) {

			var redirected = false;
			
			if (error.response) {
				if(error.response.status == 401) {
					if(error.response.data.redirect) {
						location.href = error.response.data.redirect;
						redirected = true;
					}
				}
			}

			if(!redirected) {
				new Noty({
					text: 'Não foi possível salvar. Por favor tente novamente.',
					type: 'error'
				}).show();
			}

			$this.data('locked', false);
		});

		return false;
	});
});

